import {
    required,
    maxLength,
    between,
    integer,
    numeric,
    requiredIf,
    helpers
} from 'vuelidate/lib/validators';
import store from '@/store/index';
import {CORE_PREFIX, CREATE_SHIPMENT_PREFIX, GETTERS} from '../store/constants';
const dimsValidation = (min, max) =>
    helpers.withParams({ type: 'between', min, max }, (value) => {
        var isColliDimension = store.getters['createShipment/getIsColliDimension'];

        if (isColliDimension) {
            if (value === '') {
                return false;
            }
            return (
                !helpers.req(value) ||
                ((!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value)
            );
        }
        return true;
    });
const onlyDecimalsForUS = (value) => {
    if (!store.getters[CORE_PREFIX + GETTERS.CORE.IS_US_SYSTEM]) {
        var isInteger = value % 1 === 0;
        if (!isInteger) {
            return false;
        }
    }
    return true;
};

const onlyAllowedWords = async (value) => {
    let stopWords = await store.getters[CREATE_SHIPMENT_PREFIX + GETTERS.CREATE_SHIPMENT.BLOCKED_DESCRIPTIONS];
    if(stopWords.includes(value))
        return false;
    return true;
}

export default {
    texts: {
        description: {
            required: requiredIf(() => {
                const result = store.getters['createShipment/hasShipmentOptions'];
                return result;
            }),
            maxLength: maxLength(50),
            onlyAllowedWords
        },
        sendersReference: {
            maxLength: maxLength(50),

            required: requiredIf(() => {
                const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                const viewOptions = store.getters['createShipment/getViewOptions'];

                const sendersReference = viewOptions.filter((opt) => {
                    return opt.name === 'SendersReference';
                })[0];

                return hasShipmentOptions && sendersReference.required;
            })
        },
        receiversReference: {
            maxLength: maxLength(50),

            required: requiredIf(() => {
                const hasShipmentOptions = store.getters['createShipment/hasShipmentOptions'];
                const viewOptions = store.getters['createShipment/getViewOptions'];

                const receiversReference = viewOptions.filter((opt) => {
                    return opt.name === 'ReceiversReference';
                })[0];

                return hasShipmentOptions && receiversReference.required;
            })
        }
    },

    dangerousGoods: {
        type: {
            required: requiredIf((instance) => {
                if (instance != null && !instance.type) {
                    return true;
                }
                return false;
            })
        },
        unNumber: {
            required: requiredIf((vueInstance) => {
                const isDangerousGoods = store.getters['createShipment/isDangerousGoods'];

                var isUnNumber = false;

                if (vueInstance != null) {
                    isUnNumber = vueInstance.type != 'BATTERY';
                }

                return isDangerousGoods && isUnNumber;
            }),
            maxLength: maxLength(20)
        },
        packingGroup: {
            required: requiredIf((instance) =>{
                if (instance != null) {
                    return (instance.type !== 'BATTERY');
                }
                return false;
            })
        },
        description: {
            required: requiredIf((vueInstance) => {
                const isDangerousGoods = store.getters['createShipment/isDangerousGoods'];

                var isBattery = false;

                if (vueInstance != null) {
                    isBattery = vueInstance.type === 'BATTERY';
                }

                return isDangerousGoods && isBattery;
            })
        }
    },

    collis: {
        $each: {
            weight: {
                between: between(0.1, 999999999)
            },
            length: {
                between: dimsValidation(1, 999999999),
                onlyDecimalsForUS
            },
            width: {
                between: dimsValidation(1, 999999999),
                onlyDecimalsForUS
            },
            height: {
                between: dimsValidation(1, 999999999),
                onlyDecimalsForUS
            },
            dryIce: {
                between: dimsValidation(0, 999999999)
            }
        }
    },

    colliDetails: {
        numberOfColli: {
            between: between(1, 99)
        },
        totalWeight: {
            between: between(0.1, 999999999)
        },
        totalDryIceWeight: {
            between: between(0, 999999999)
        }
    }
};
